import PickerOriginal from '@emoji-mart/react'

/* reexported with a TS type because original module has default export */
export const Picker = PickerOriginal as unknown as typeof PickerOriginal.default
